import axiosInstance from './axiosInstance';

export const getFacultyCourses = async () => {
  const res = await axiosInstance.get('/courses/faculty');
  return res.data?.data || [];
};

export const createCourse = async (payload) => {
  const res = await axiosInstance.post('/courses', payload);
  return res.data?.data;
};

export const updateCourse = async (id, payload) => {
  const res = await axiosInstance.put(`/courses/${id}`, payload);
  return res.data?.data;
};

export const deleteCourse = async (id) => {
  const res = await axiosInstance.delete(`/courses/${id}`);
  return res.data;
};
